import { PolygonType } from 'src/app/bo/polygon/tirsPolygone';

export const MAP_PROJECTION = 'EPSG:3857';
export const WGS84_PROJECTION = 'EPSG:4326';

export const HOLES_MAX_RESOLUTION = 0.5;
export const DEFAULT_SITE_ZOOM = 15;
export const FALLBACK_CENTER_LON_LAT: [number, number] = [4.7778, 43.608];
export const SATELLITE_EXTENT_METERS = 20000;
export const SCALE_BAR_TARGET_PX = 80;
export const POPUP_TOP_RESERVED_PX = 72;
export const POPUP_CHROME_PX = 12 + 2 * 15 + 2;

/** Seul site où l'ancienne carte (CvnSiteId) active l'affichage des équipements ; à terme, à déduire de la configuration. */
export const EQUIPMENT_SITE_ID = 189;

export const Z_INDEX = {
  osm: 0,
  satellite: 1,
  orthophotos: 2,
  dxf: 1005,
  zonesOfInterest: 1010,
  blastPolygons: 1020,
  holes: 1030,
  controlPoints: 1040,
  equipments: 1050,
  measure: 1100,
} as const;

export const FEATURE_KIND = 'siteMapKind';
export const FEATURE_BLAST_ID = 'blastId';
export const FEATURE_BLAST_NAME = 'blastName';
export const FEATURE_POLYGON_TYPE = 'polygonType';
export const FEATURE_POLYGON_ID = 'blastPolygonId';
export const FEATURE_HOLE = 'hole';
export const FEATURE_LABEL = 'label';

export const ALL_POLYGON_TYPES: PolygonType[] = [
  PolygonType.AutomaticFromHoles,
  PolygonType.DrillingContour,
  PolygonType.MuckPile,
  PolygonType.DangerZone,
];
export const DEFAULT_POLYGON_TYPES: PolygonType[] = [PolygonType.DrillingContour, PolygonType.AutomaticFromHoles];

export const DEFAULT_POLYGON_FILL = 'rgba(145, 40, 59, 0.8)';
export const KPI_NO_VALUE_FILL = 'rgba(255, 255, 255, 0.8)';

export const MAPBOX_ATTRIBUTIONS =
  '© <a href="https://www.mapbox.com/about/maps/">Mapbox</a> © <a href="https://www.openstreetmap.org/copyright">OpenStreetMap</a>';

/** URL des tuiles satellite Mapbox (bouton « Map »). */
export function mapboxSatelliteUrl(token: string): string {
  return `https://api.mapbox.com/styles/v1/mapbox/satellite-v9/tiles/256/{z}/{x}/{y}@2x?access_token=${token}`;
}
